import z from "zod";

/**
 * InspecaoObraOcorrenciaSchema
 */

export const InspecaoObraOcorrenciaSchema = z.object({
  idItemInspecao: z.number().nullable().default(null),
  inspecao: z.coerce.number().nullable().default(null),
  dataDescricao: z.coerce.date().nullable().default(null),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),
  dataTratativa: z.coerce.date().nullable().default(null),
  tratativa: z.string().nullable().default(null),
});

/**
 * InspecaoObraOcorrenciaForm
 */

export type InspecaoObraOcorrenciaForm = z.infer<typeof InspecaoObraOcorrenciaSchema>;